import { http, HttpResponse } from 'msw';

const svgs = [
  http.get('https://fuel-ds.fretebras.com.br/svg/icons/:type/:name.svg', ({ params }) => {
    const { type, name } = params;

    return HttpResponse.text(
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <text x="10" y="15" font-size="2">
          Mocked SVG: ${type}/${name}
        </text>
       </svg>`,
      {
        status: 200,
        headers: {
          'Content-Type': 'image/svg+xml',
        },
      }
    );
  }),
];

export { svgs };
